import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import Moment from "moment";
import isEqual from 'lodash/isEqual';
import cloneDeep from 'lodash/cloneDeep';
import Typography from '@mui/material/Typography';



import * as utils from "../utils";
import {numeral as Numeral} from "../utils";

import AuthContext from "./auth/Context";
import GroupTabs from "./GroupTabs";
import createDefaults from "./createDefaults";

class Form extends React.Component{
  constructor(props){
    super(props);
    this.state={
      data:cloneDeep(this.props.data||{}),
      load:0
    }
    this.handleValueChanged = this.handleValueChanged.bind(this);
    this.prepareFields = this.prepareFields.bind(this);
    this.getData = this.getData.bind(this);
    this.getMaster = this.getMaster.bind(this);
  }
  async componentDidMount(){
    if(!this.props.fields && !this.props.listInfo && this.props.code && !this.fields){
      const listInfo = await this.context.apis.asyncGetData(this.context.userInfo?this.context.getToken():this.context.config.public_token,"listinfo",{code:this.props.code.toLowerCase()},null,true,true);
      if(listInfo && listInfo.fields){
        //create default
        let {data} = this.state;
        if(Object.keys(data).length==0){
          let defaultData = {};
          await createDefaults(defaultData,listInfo.fields,this.context)
          data = {...defaultData,...data}
          this.setState({data,load:this.state.load+1},async ()=>{
            await this.prepareFields(listInfo.fields);
          })
        }else{
          await this.prepareFields(listInfo.fields);
        }
      }
      
    }else{
      await this.prepareFields(this.props.fields);
    }
  }
  shouldComponentUpdate(nextProps,nextState){
    if(nextState.load!==this.state.load) return true;
    
    if(!isEqual(nextProps.data,this.state.data)){
    //if(!isEqual(nextProps.data,this.props.data)){
      //console.log("props data changed");
      // eslint-disable-next-line react/no-direct-mutation-state
      this.state.data = cloneDeep(nextProps.data);
      this.prepareFields(nextProps.fields);
      return true;
    }
    if(!isEqual(nextProps.fields,this.props.fields)){
      //console.log("fields on formbase:",this.props.code);
      this.prepareFields(nextProps.fields);
      return true;
    }
    return false;
  }
  getData(){
    return this.state.data;
  }
  getMaster(){
    return this.props.master;
  }
  async prepareFields(fields){
    if(!fields) return;
    //fields need to handle header
    await Promise.all((fields||[]).filter(f=>(f.header_source || f.header).indexOf("return ")>=0).map(field=>{
      return (async ()=>{
        let body_func = field.header_source || field.header;
        body_func =`return (async ()=>{
          ${body_func}
        })()`;
        try{
          const func  = new Function("master","Moment","Numeral","API","utils","context","field","listInfo",body_func);
          let header = await func(this.state.data||{},Moment,Numeral,this.context.apis,utils,this.context,field,{fields});
          field.header_source = field.header_source || field.header;
          field.header = header;
        }catch(e){
          console.error(e.message,field.header,body_func);
        }
      })();
    }));
    //
    this.fields = cloneDeep(fields);
    if(this.props.readOnly){
      this.fields = this.fields.filter(field=>field.on_view);
    }
    this.fields.forEach(f=>{
      f.tab = f.tab||"";
      f.group = f.group||"";
      if(!f.group && !f.tab && f.type!=="Group") f.tab = "master";
      if(f.group===f.name && f.type==="Group") f.group ="";
      
    })
    this.masterFields = cloneDeep(this.fields.filter(f=>f.tab==="master"));
    this.masterFields.forEach(f=>{
      f.tab ="";
    })

    this.summaryFields = cloneDeep(this.fields.filter(f=>f.tab==="summary"));
    this.summaryFields.forEach(f=>{
      f.tab ="";
    })

    this.footerFields = cloneDeep(this.fields.filter(f=>f.tab==="footer"));
    this.footerFields.forEach(f=>{
      f.tab ="";
    })
    this.fieldsTab = this.fields.filter(f=>!(f.tab==="footer") && !(f.tab==="master") && !(f.tab==="summary") );
    this.setState({load:this.state.load+1});
  }
  async handleValueChanged(_data){
    let {data} = this.state;
    for(let key in _data){
      data[key] = _data[key];
    }
    this.setState({data,load:this.state.load+1});
    if(this.props.handleValueChanged) this.props.handleValueChanged(data);
  }
  render(){
    if(!this.fields) return null;
    return (
      <div style={this.props.style} class="flex-formbase">
        <div style={{display:"flex",flexDirection:"column",width:"100%",height:"100%"}}>
          {this.masterFields.length>0 &&
            <div key="master-session" class="flex-master-session">
              <GroupTabs
                idApp={this.props.idApp}
                inline={this.props.inline}
                code = {this.props.code}
                name="master"
                orientation ={this.props.orientationTab}
                backgroundColorBar={this.props.backgroundColorBarTab}
                backgroundColorFields={this.props.backgroundColorFieldsTab}
                //style={{padding:5}}
                style={{maxHeight:(this.props.style||{}).maxHeight}}
                master={this.props.master}
                data={this.state.data} 
                fields={this.masterFields}
                group={""}
                readOnly={this.props.readOnly}
                noValidate = {this.props.noValidate}
                dataPickers = {this.props.dataPickers}
                parent = {this.props.parent}
                mainForm = {this}
                mediaQueryMatches = {this.props.mediaQueryMatches}
                handleValueChanged={this.handleValueChanged.bind(this)}/>
            </div>
          }
          {this.fieldsTab.length>0 &&
            <div  key="root-tabs-session"  class="flex-tabs-session" style={{flexGrow:1,flex:1,overflow:"auto"}}>
              <GroupTabs
                idApp={this.props.idApp}
                inline={this.props.inline}
                code = {this.props.code}
                name="detail"
                orientation ={this.props.orientationTab}
                backgroundColorBar={this.props.backgroundColorBarTab}
                backgroundColorFields={this.props.backgroundColorFieldsTab}
                style={{maxHeight:(this.props.style||{}).maxHeight}}
                master={this.props.master}
                data={this.state.data} 
                fields={this.fieldsTab}
                group={""}
                readOnly={this.props.readOnly}
                noValidate = {this.props.noValidate}
                dataPickers = {this.props.dataPickers}
                parent = {this.props.parent}
                mainForm = {this}
                mediaQueryMatches = {this.props.mediaQueryMatches}
                handleValueChanged={this.handleValueChanged.bind(this)}/>
            </div>
          }
          {this.summaryFields.length>0 && !this.context.queryParams.no_input_summary && 
            <div   key="summary-session" class="flex-summary-session"  style={{borderTop:!this.props.mediaQueryMatches?"1px dotted silver":undefined,backgroundColor:"#f5f5f5"}}>
              <Grid   container justifyContent="space-between" alignItems="flex-end">
                {!!this.state.data.user_created && !this.props.mediaQueryMatches &&
                  <Grid
                    style={{padding:10}}
                    size={{
                      xs: 12,
                      sm: 12,
                      md: 3,
                      lg: 3
                    }}>
                    <Typography component='div'><small><i style={{fontSize:9}}>{`${this.context.apis.getLabel("Tạo bởi ")} ${this.state.data.user_created.split("@")[0]} ${this.context.apis.getLabel("lúc")} ${Moment(this.state.data.date_created).format("DD/MM/YY HH:mm A")}`}</i></small></Typography>
                    <Typography component='div'><small><i style={{fontSize:9}}>{`${this.context.apis.getLabel("Cập nhật lần cuối  bởi ")} ${this.state.data.user_updated.split("@")[0]} ${this.context.apis.getLabel("lúc")} ${Moment(this.state.data.date_updated).format("DD/MM/YY HH:mm A")}`}</i></small></Typography>
                  </Grid>
                }
                <Grid
                  size={{
                    xs: 12,
                    sm: 12,
                    md: !!this.state.data.user_created && !this.props.mediaQueryMatches?9:12,
                    lg: !!this.state.data.user_created && !this.props.mediaQueryMatches?9:12
                  }}>
                  <GroupTabs
                      idApp={this.props.idApp}
                      inline={this.props.inline}
                      code = {this.props.code}
                      name="summary"
                      justify="flex-end"
                      orientation ={this.props.orientationTab}
                      backgroundColorBar={this.props.backgroundColorBarTab}
                      backgroundColorFields={this.props.backgroundColorFieldsTab}
                      style={{maxHeight:(this.props.style||{}).maxHeight}}
                      master={this.props.master}
                      data={this.state.data} 
                      fields={this.summaryFields}
                      group={""}
                      readOnly={this.props.readOnly}
                      noValidate = {this.props.noValidate}
                      dataPickers = {this.props.dataPickers}
                      parent = {this.props.parent}
                      mainForm = {this}
                      mediaQueryMatches = {this.props.mediaQueryMatches}
                      handleValueChanged={this.handleValueChanged.bind(this)}/>
                </Grid>
              </Grid>
            </div>
          }
          {this.footerFields.length>0 &&
            <div key="footer-session" class="flex-footer-session">
              <GroupTabs
                  idApp={this.props.idApp}
                  inline={this.props.inline}
                  code = {this.props.code}
                  name="footer"
                  orientation ={this.props.orientationTab}
                  backgroundColorBar={this.props.backgroundColorBarTab}
                  backgroundColorFields={this.props.backgroundColorFieldsTab}
                  //style={{padding:5}}
                  style={{maxHeight:(this.props.style||{}).maxHeight}}
                  master={this.props.master}
                  data={this.state.data} 
                  fields={this.footerFields}
                  group={""}
                  readOnly={this.props.readOnly}
                  noValidate = {this.props.noValidate}
                  dataPickers = {this.props.dataPickers}
                  parent = {this.props.parent}
                  mainForm = {this}
                  mediaQueryMatches = {this.props.mediaQueryMatches}
                  handleValueChanged={this.handleValueChanged.bind(this)}/>
            </div>
          }
        </div>
      </div>
    );
  }
}
Form.contextType = AuthContext;
Form.propTypes={
  code:PropTypes.string,
  idApp:PropTypes.string,
  orientationTab:PropTypes.oneOf(["vertical","horizontal"]),
  backgroundColorBarTab:PropTypes.string,
  backgroundColorFieldsTab:PropTypes.string,
  fields:PropTypes.arrayOf(PropTypes.object),
  handleValueChanged:PropTypes.func.isRequired,
  inline:PropTypes.bool,//inline form, Tất cả các field sẽ nằm trên một dòng
  data:PropTypes.object,
  master:PropTypes.object,
  dataPickers:PropTypes.object,
  noValidate:PropTypes.bool,
  history:PropTypes.any,
  parent:PropTypes.any,
  readOnly:PropTypes.bool,
  style:PropTypes.any,
}
export default Form;
